/**
 * KFV custom - designed in Canvas/Sidekick 2026-10-19, ported to Dawn 16.1.0 2026-10-21
 * Mobile product lightbox (screens <= 749px only), used by sections/main-product.liquid
 * on all product templates. Styles live in assets/kfv-mobile-gallery.css.
 * - Swipe left/right between all media; opens on the tapped one
 * - Pinch with two fingers to zoom an image (1x to 5x); when zoomed, drag with one finger to pan
 * - Single tap on an image or the empty overlay closes the lightbox; taps on videos,
 *   3D models, buttons and links do what they normally do
 * - Settling on another slide resets the zoom and pauses media on the other slides
 * - 2026-10-21: progress dots at the bottom show there is more to swipe and which slide is
 *   on screen; tapping a dot jumps to it. Over MAX_DOTS slides they become an "n / total" counter
 * Listeners are attached to each product modal the first time it opens, so modals replaced
 * by a product swap still get them. Requires the section's "Image zoom" setting = "Lightbox".
 */
(function () {
  var SELECTOR = 'product-modal[id^="ProductModal-"]';
  var mobile = window.matchMedia('(max-width: 749px)');
  var img = null, scale = 1, tx = 0, ty = 0;
  var startDist = 0, startScale = 1, px = 0, py = 0, baseL = 0, baseT = 0;
  var lastX = 0, lastY = 0, tapStart = 0, tapX = 0, tapY = 0, multi = false;

  function content(modal) {
    return modal.querySelector('.product-media-modal__content');
  }
  function apply() {
    if (img) img.style.transform = scale === 1 ? '' : 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')';
  }
  function reset(modal) {
    modal.querySelectorAll('.product-media-modal__content > img').forEach(function (el) {
      el.style.transform = '';
    });
    modal.classList.remove('kfv-zoomed');
    img = null; scale = 1; tx = 0; ty = 0;
  }
  function dist(t) {
    return Math.hypot(t[0].clientX - t[1].clientX, t[0].clientY - t[1].clientY);
  }
  // The slide whose centre is closest to the centre of the strip.
  function current(modal) {
    var c = content(modal);
    if (!c) return null;
    var mid = c.getBoundingClientRect().left + c.clientWidth / 2, best = null, bestD = Infinity;
    Array.prototype.forEach.call(c.children, function (el) {
      var r = el.getBoundingClientRect();
      if (!r.width) return; // hidden variant media
      var d = Math.abs(r.left + r.width / 2 - mid);
      if (d < bestD) { bestD = d; best = el; }
    });
    return best;
  }
  // Same calls as pauseAllMedia() in assets/global.js, limited to the slides not on screen.
  function pauseOthers(modal, keep) {
    Array.prototype.forEach.call(content(modal).children, function (el) {
      if (el === keep) return;
      el.querySelectorAll('.js-youtube').forEach(function (v) {
        v.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
      });
      el.querySelectorAll('.js-vimeo').forEach(function (v) {
        v.contentWindow.postMessage('{"method":"pause"}', '*');
      });
      el.querySelectorAll('video').forEach(function (v) { v.pause(); });
      el.querySelectorAll('product-model').forEach(function (m) {
        if (m.modelViewerUI) m.modelViewerUI.pause();
      });
    });
  }
  // Dawn's showActiveMedia() resets scrollLeft to ~0 after scrollIntoView(); line the
  // tapped slide up again.
  function align(modal) {
    var c = content(modal);
    var active = c && c.querySelector(':scope > .active');
    if (!active) return;
    c.scrollLeft += active.getBoundingClientRect().left - c.getBoundingClientRect().left;
  }
  // 2026-10-21 Progress dots. The bar lives in the dialog, which survives the content
  // re-render on variant change; it is rebuilt on every open from the visible slides
  // (hidden variant media excluded). Styles: [6] in assets/kfv-mobile-gallery.css.
  var MAX_DOTS = 20;
  function slides(modal) {
    return Array.prototype.filter.call(content(modal).children, function (el) {
      return el.getBoundingClientRect().width > 0;
    });
  }
  function buildDots(modal) {
    var dialog = modal.querySelector('.product-media-modal__dialog');
    var bar = dialog.querySelector('.kfv-lightbox-dots');
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'kfv-lightbox-dots';
      bar.addEventListener('click', function (e) {
        var dot = e.target.closest('button');
        if (!dot) return;
        var c = content(modal);
        c.scrollTo({ left: Number(dot.dataset.index) * c.clientWidth, behavior: 'smooth' });
      });
      dialog.appendChild(bar);
    }
    var n = slides(modal).length;
    bar.hidden = !mobile.matches || n < 2;
    bar.innerHTML = '';
    if (n > MAX_DOTS) {
      bar.appendChild(document.createElement('span')).className = 'kfv-lightbox-dots__count';
    } else {
      for (var i = 0; i < n; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.dataset.index = i;
        dot.setAttribute('aria-label', i + 1 + ' / ' + n);
        bar.appendChild(dot);
      }
    }
    bar.dataset.total = n;
    updateDots(modal);
  }
  function updateDots(modal) {
    var bar = modal.querySelector('.kfv-lightbox-dots');
    var c = content(modal);
    if (!bar || bar.hidden || !c.clientWidth) return;
    var total = Number(bar.dataset.total);
    var idx = Math.max(0, Math.min(total - 1, Math.round(c.scrollLeft / c.clientWidth)));
    var count = bar.querySelector('.kfv-lightbox-dots__count');
    if (count) { count.textContent = idx + 1 + ' / ' + total; return; }
    Array.prototype.forEach.call(bar.children, function (dot, i) {
      if (i === idx) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    });
  }

  // A tap closes only on an image or the empty overlay, never on media controls.
  function closesOnTap(target) {
    if (target.closest('deferred-media, product-model, .product-media-modal__model, video, iframe, button, a')) return false;
    return target.matches('.product-media-modal__content > img, .product-media-modal__content, .product-media-modal__dialog, ' + SELECTOR);
  }

  function bind(modal) {
    var settle = null, shown = null, dotsFrame = 0;

    modal.addEventListener('touchstart', function (e) {
      if (!mobile.matches) return;
      var target = e.target.closest('.product-media-modal__content > img');
      if (target && target !== img) { reset(modal); img = target; }
      var t = e.touches;
      if (t.length === 1) {
        lastX = tapX = t[0].clientX; lastY = tapY = t[0].clientY;
        tapStart = Date.now(); multi = false;
      } else if (t.length === 2 && img) {
        multi = true;
        var r = img.getBoundingClientRect();
        baseL = r.left - tx; baseT = r.top - ty;
        var mx = (t[0].clientX + t[1].clientX) / 2, my = (t[0].clientY + t[1].clientY) / 2;
        startDist = dist(t); startScale = scale;
        px = (mx - baseL - tx) / scale; py = (my - baseT - ty) / scale;
      }
    }, { passive: true });

    modal.addEventListener('touchmove', function (e) {
      if (!mobile.matches || !img) return;
      var t = e.touches;
      if (t.length === 2) {
        if (e.cancelable) e.preventDefault();
        var mx = (t[0].clientX + t[1].clientX) / 2, my = (t[0].clientY + t[1].clientY) / 2;
        scale = Math.min(5, Math.max(1, startScale * dist(t) / startDist));
        tx = scale === 1 ? 0 : mx - baseL - px * scale;
        ty = scale === 1 ? 0 : my - baseT - py * scale;
        modal.classList.toggle('kfv-zoomed', scale > 1);
        apply();
      } else if (t.length === 1 && scale > 1) {
        if (e.cancelable) e.preventDefault();
        tx += t[0].clientX - lastX; ty += t[0].clientY - lastY;
        lastX = t[0].clientX; lastY = t[0].clientY;
        apply();
      }
    }, { passive: false });

    modal.addEventListener('touchend', function (e) {
      if (!mobile.matches || e.touches.length > 0 || multi) return;
      var c = e.changedTouches[0];
      var moved = Math.hypot(c.clientX - tapX, c.clientY - tapY);
      if (Date.now() - tapStart < 300 && moved < 10 && closesOnTap(e.target)) {
        e.preventDefault(); // stop the tap from reopening the image underneath
        reset(modal);
        modal.hide();
      }
    }, { passive: false });

    // scroll doesn't bubble, so listen in the capture phase for the strip's scrolling.
    modal.addEventListener('scroll', function (e) {
      if (!mobile.matches || !e.target.classList || !e.target.classList.contains('product-media-modal__content')) return;
      // 2026-10-21 Move the active dot while swiping, once per frame.
      if (!dotsFrame) dotsFrame = requestAnimationFrame(function () { dotsFrame = 0; updateDots(modal); });
      clearTimeout(settle);
      settle = setTimeout(function () {
        var now = current(modal);
        if (!now || now === shown) return;
        shown = now;
        if (img && img !== now) reset(modal);
        pauseOthers(modal, now);
      }, 150);
    }, true);

    modal.kfvShown = function (el) { shown = el; };
  }

  new MutationObserver(function (records) {
    records.forEach(function (r) {
      var modal = r.target;
      if (!modal.matches(SELECTOR) || !modal.hasAttribute('open')) return;
      if (!modal.kfvBound) { modal.kfvBound = true; bind(modal); }
      reset(modal);
      var bar = modal.querySelector('.kfv-lightbox-dots');
      if (!mobile.matches) { if (bar) bar.hidden = true; return; }
      requestAnimationFrame(function () {
        align(modal);
        modal.kfvShown(current(modal));
        buildDots(modal); // 2026-10-21 after align(), so the right dot starts active
      });
    });
  }).observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['open'] });
})();
